import React, {
    useState,
    useEffect,
    InputHTMLAttributes,
} from "react";

import { EditOutlined } from "@ant-design/icons";


interface EditableNumberCellProps
    extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange" | "value"> {
    value: number;
    onChange: (value: number) => void;
    tdClassName?: string;
    inputClassName?: string;
    alwaysEditable?: boolean;
}

const EditableNumberCell: React.FC<EditableNumberCellProps> = ({
                                                                   value,
                                                                   onChange,
                                                                   tdClassName = "",
                                                                   inputClassName = "",
                                                                   alwaysEditable = false,
                                                                   ...inputProps // 👈 here we pass min, max, step, etc.
                                                               }) => {
    const [editing, setEditing] = useState(alwaysEditable);
    const [internalValue, setInternalValue] = useState<string>(String(value));

    useEffect(() => {
        setInternalValue(String(value));
    }, [value]);

    const commitChange = () => {
        const parsed = Number(internalValue);
        if (!isNaN(parsed)) {
            onChange(parsed);
        }
        if (!alwaysEditable) {
            setEditing(false);
        }
    };

    return (
        <div
            className={`${tdClassName} ${
                !alwaysEditable ? "cursor-pointer" : ""
            }`}
            onClick={() => {
                if (!alwaysEditable) setEditing(true);
            }}
        >
            {editing ? (
               <div>
                   <input
                       type="number"
                       value={internalValue}
                       autoFocus={!alwaysEditable}
                       onChange={(e) => setInternalValue(e.target.value)}
                       onBlur={commitChange}
                       onKeyDown={(e) => {
                           if (e.key === "Enter") commitChange();
                       }}
                       className={`w-full  rounded px-2 py-1 ${inputClassName}`}
                       {...inputProps}
                   />

               </div>

                ) : (
                <div> {value} <EditOutlined className="text-gray-400 hover:text-blue-500 cursor-pointer" /> </div>
            )}

        </div>
    );
};

export default EditableNumberCell;